// Constants for Invitation - External (DMUT).
//
// This is the DMUT-facing (external) side of the invitation issued during
// Planning / Procurement: the logged-in DMUT sees the invitations addressed to
// them and either Accepts or Declines. Everything on the Detail page is view-only
// — the DMUT reads what the buyer captured upstream; the only writes are the
// Accept / Decline actions.
//
// TODO(API): no backend contract exists for this screen yet (nothing under
// api_contract/ mentions an external/DMUT invitation). The module runs on the
// in-memory store in invitationExternalStore.js behind the
// invitationExternalApi.js facade — swapping to live endpoints is confined to
// that one file. The enum spellings below are the values expected on the wire
// (C# member names, as everywhere else in this project), NOT display labels.

// Invitation status for the logged-in DMUT.
//
// EXPIRED is not a stored state — it is derived: an invitation still sitting at
// OPEN once its Submission Deadline has passed reads as Expired ("expired jika
// sampai waktu validity submission berakhir tidak di Accept atau di Reject").
// The derivation lives in invitationExternalStore.deriveStatus so the list, the
// detail page and the Accept/Decline guards all agree.
export const INVITATION_STATUS = {
  OPEN: 'Open',
  ACCEPTED: 'Accepted',
  DECLINED: 'Declined',
  EXPIRED: 'Expired',
};

export const INVITATION_STATUS_BADGE = {
  [INVITATION_STATUS.OPEN]: 'warning',
  [INVITATION_STATUS.ACCEPTED]: 'success',
  [INVITATION_STATUS.DECLINED]: 'danger',
  [INVITATION_STATUS.EXPIRED]: 'secondary',
};

// Accept / Decline are offered only while the invitation is genuinely Open —
// i.e. status OPEN and the deadline not yet passed. Because EXPIRED is derived
// from the same deadline, testing for OPEN alone is sufficient here.
export const canRespond = status => status === INVITATION_STATUS.OPEN;

// Document source labels (documents are carried over from Planning and
// Procurement — both stages feed this list, filtered to showToDmut = true).
export const DOC_SOURCE = {
  PLANNING: 'Planning',
  PROCUREMENT: 'Procurement',
};

export const DOC_SOURCE_BADGE = {
  [DOC_SOURCE.PLANNING]: 'info',
  [DOC_SOURCE.PROCUREMENT]: 'primary',
};

// Keyword search covers Title, Id Procurement and Description only (DOD item 2).
// Any other visible column is deliberately not searchable.
export const SEARCHABLE_FIELDS = ['procId', 'title', 'description'];

// Sortable columns — every column except Action (DOD item 6).
export const SORTABLE_FIELDS = [
  'procId',
  'title',
  'procurementType',
  'procurementMethod',
  'description',
  'invitationStatus',
];

export const DEFAULT_PAGE_SIZE = 10; // DOD item 4
